// Types
import {
  InitAuthState,
  InitUserState,
} from '../types/contexts/AuthContextTypes'
import {
  InitCartState,
  InitAutoShipState,
} from '../types/contexts/CartContextTypes'
import { InitStoreState } from '../types/contexts/StoreContextTypes'
// Utils
import environment from '../utils/environment'

const initialAuthState: InitAuthState = {
  isAuthenticated: false,
  isAuthLoading: true,
  isEventSite: environment.IS_EVENT_SITE,
  isFirstLogin: false,
  isVerified: false,
  isVipSite: environment.IS_VIP_SITE,
}

const initialUserState: InitUserState = {
  cardsOnFile: [],
  isEnrollmentComplete: false,
  isReferral: false,
  magentoUser: null,
  qUser: null,
  qUserUpline: null,
  referralData: null,
  shouldAddPcFee: false,
  userType: 'RETAIL',
}

const initialStoreState: InitStoreState = {
  isLandingPageLoading: true,
  isStoreLoading: true,
  landingPageData: {},
  storeData: {},
}

const initialCartState: InitCartState = {
  cartData: null,
  cartId: '',
  guestCartId: '',
  isAmbOfferInCart: false,
  isPcOfferInCart: false,
  isPlacingOrder: false,
  isShippingSet: false,
  isShowCartPopup: false,
}

const initialAutoShipState: InitAutoShipState = {
  autoShipAddress: null,
  autoShipData: null,
  autoShipDate: '',
  autoShipId: 0,
  autoShipItems: [],
  autoShipPaymentInformationId: null,
}

export {
  initialAuthState,
  initialAutoShipState,
  initialCartState,
  initialStoreState,
  initialUserState,
}
